import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function CheckoutCancel() {
  const [params] = useSearchParams();
  const packageId = params.get("package_id");
  return (
    <div className="relative">
      <Header />
      <main className="pt-32 md:pt-40 min-h-[80vh] flex items-start justify-center">
        <div className="max-w-xl w-full mx-auto px-6 md:px-10 py-12">
          <div className="border border-white/10 bg-black/40 p-8 md:p-12 text-center">
            <AlertCircle className="w-14 h-14 text-white/70 mx-auto" strokeWidth={1.5} />
            <p className="overline mt-6 text-white/60">Payment Cancelled</p>
            <h1 className="font-serif-display text-3xl md:text-4xl mt-3 leading-tight">
              No charge made.
            </h1>
            <p className="text-white/60 mt-4 font-light leading-relaxed">
              You cancelled before completing payment. Your spot is still open — pick up right where you left off.
            </p>
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              <Link
                to="/#collection"
                data-testid="cancel-collection-btn"
                className="inline-flex items-center gap-2 bg-[#D4AF37] text-black px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all"
              >
                Back To The Collection<ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 border border-white/20 px-7 py-4 text-xs uppercase tracking-[0.22em] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all"
              >
                Return Home
              </Link>
            </div>
            {packageId && <p className="text-white/30 text-[10px] font-mono mt-8">pkg: {packageId}</p>}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
